import React from "react";
import style from "./Home.module.css";
import { Routes, Route, Link, Navigate } from 'react-router-dom';
import { QtdContext } from "../../../context/qtdContext";
import Button from '../../../components/Button/Button'
import PaginationComponent from '../../../components/Pagination/Pagination.js'
import 'react-tabs/style/react-tabs.css';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { FcCancel, FcEngineering, FcInfo } from "react-icons/fc";
import $api from '../../../http/index.ts'
import './react-confirm-alert.css'; // Import css
import DatePicker from "react-datepicker";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import Calendar from 'react-calendar';
import { SiMicrosoftexcel } from "react-icons/si";
import 'react-calendar/dist/Calendar.css';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
// import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import 'react-accessible-accordion/dist/fancy-example.css';
import { useEffect, useState, useContext } from "react";
import LinksMenu from "../../../components/Header/LinksMenu";
// import AddProductModal from "../../../components/Modals/AddProductModal";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { BACKURL } from '../../../conf.js'
import Loading from 'react-fullscreen-loading';
// import AddEmployeesModal from "../../../components/Modals/Emloyees/AddEmployeesModal.js";
// import EditEmployeesModal from "../../../components/Modals/Emloyees/EditEmployeesModal.js";
// import AddRecieptModal from "../../../components/Modals/Reciepts/AddRecieptModal.js";
// import RecieptListModal from "../../../components/Modals/Reciepts/RecieptListModal.js";
import { CiFloppyDisk } from "react-icons/ci";
import { RiFileDownloadLine } from "react-icons/ri";
import CreateSRModal from "../../../components/Modals/Reports/CreateSaleReport.js";
import styled from "styled-components";
import SRListModal from "../../../components/Modals/Reports/SRListModal.js";
import { ru } from 'date-fns/locale';
import SaleReportShort from "../../../components/Modals/Reports/SaleReportShort.js";
import SaleReportShowById from "../../../components/Modals/Reports/SaleReportShowById.js";
import SaleReportShowByIdEdit from "../../../components/Modals/Reports/SaleReportShowByIdEdit.js";
import SaleReport from "../../../components/Modals/Reports/SaleReport.js";
import EditSaleReportForm from "../../../components/Modals/Reports/EditSaleReportForm.js";
import AvansReport from "../../../components/Modals/Reports/AvansReport.js";
import AvansReportForm from "../../../components/Modals/Reports/AvansReportForm.js";
import WeekReports from "./WeekReports.jsx";
type ValuePiece = Date | null;

type Value = ValuePiece | [ValuePiece, ValuePiece];
const ReportsPage = () => {
  const { avansReportsFormsModal, saleReportShowById, saleReportShowByIdEdit, setSaleReportShowByIdEdit, setSaleReportShowById, setAvansReportsFormsModal, avansReportsForms, setAvansReportsForms, setAvansReportModal, avansReportModal, setAvansReports, avansReports, saleReportShortShow, setSaleReportShortShow, checkAuth, editSaleReportForm, setEditSaleReportForm, saleReportShow, setSaleReportShow, Notify, srListModal, saleReports, setSaleReports, setSRListModal, saleReportForms, setSaleReportForms, shops, createSRModal, setCreateSRModal, editRecieptModal, setEditRecieptModal, setReciepts, recieptListModal, setRecieptListModal, reciepts, addReciepModal, setAddRecieptModal, editEmployeesModal, setEditEmployeesModal, admin, admins, setAdmins, addEmployeesModal, setAddEmployeesModal, setDashboarPage, smenas } = useContext(QtdContext);
  const [loading, seloading] = useState(false)
  const [form_id, setForm_id] = useState(null)
  const animatedComponents = makeAnimated();
  const [id, setId] = useState('')
  const [srid, stSrid] = useState(null)
  const opendSmenas = smenas.find(pr => pr.open)
  const [orderId, setOrderId] = useState({})
  const [valueCalendar, onChangeCalendar] = useState<Value>(new Date());
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setpageCount] = useState(15);
  const [endDate, setEndDate] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [shop, setShop] = useState(null);
  const itemsPerPage = 10;
  const [values, setValues] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [pageForms, setPageForms] = useState(1);
  const [pageSizeForms, setPageSizeForms] = useState(5);

  // const [setSelectedShop, setStartDateForm] = useState(null);
  const [startDateForm, setStartDateForm] = useState(null);
  const [endDateForm, setEndDateForm] = useState(null);
  const [selectedShop, setSelectedShop] = useState(null);
  const [formErr, setFormErr] = useState(null);
  const [dateRange, setDateRange] = useState([null, null]);
  const [showCalendar, setShowCalendar] = useState(false);

  const handleDateChange2 = (range) => {
    setDateRange(range);

    setShowCalendar(false); // Скрыть календарь после выбора диапазона
  };

  const onChangeCalendar1 = async (options) => {
    // Selected options...
    onChangeCalendar(options)
    // console.log("options...", options);
    seloading(true)
    try {
      // setSelectedValues(options);
      // console.log(new Date(options))
      // console.log(new Date(startDate))
      const data = await $api.post(`${BACKURL}/api/salereports/getall/${1}`, {
        pageSize: 20, shops: selectedValues.map(pr => pr.value), startdate: new Date(options), enddate: new Date(options)
      })
      setCurrentPage(1);
      setpageCount(20)
      setSaleReports(data.data)
      seloading(false)
    } catch (e) {
      // console.log(e)
      seloading(false)
    }
  };



  const [selectedReport, setSelectedReport] = useState(null);
  useEffect(() => {

    shops.map(pr => { return { value: pr.id, label: pr.name } })
    const data = shops.map(pr => { return { value: pr.id, label: pr.name } })

    setValues(data);
    setSelectedValues(data);


    const AvansReports2 = async () => {
      seloading(true)
      const data = await $api.post(`${BACKURL}/api/salereports/getall/${1}`, { pageSize: pageCount, shops: shops.map(pr => pr.id), startdate: startDate, enddate: endDate })

      setSaleReports(data.data)
      seloading(false)


    }
    AvansReports2()
  }, []);


  if (!(admin.role == 'AllRights' || admin.role == 'Администратор')) {
    setDashboarPage('Home')
    // setAdmin({ auth: false});
    return <Navigate to="/" replace />

  } else {

    const TCheckBox = styled.input.attrs(props => ({
      type: "checkbox"
    }))`
      display: none;
    `;
    const TCheckBoxWrapper = styled.div<{ checked: boolean }>`
      background: ${p => (p.checked ? "#3f81ff" : "#ececec")};
      border-radius: 4rem;
      height: 32px;
      width: 68px;
      position: relative;
      transition: cubic-bezier(0.56, 0, 0.38, 1) 0.3s;
      cursor: pointer;
    `;

    const TCheckBoxToggle = styled.div<{ checked: boolean }>`
      background: #fff;
      border-radius: 4rem;
      height: 26px;
      width: 26px;
      top: 3px;
      left: ${p => (p.checked ? "38px" : "4px")};
      position: absolute;
      transition: cubic-bezier(0.56, 0, 0.38, 1) 0.3s;
    `;
    const ToggleCheckbox = props => {
      return (
        <TCheckBoxWrapper checked={props.checked} onClick={props.onChange}>
          <TCheckBoxToggle checked={props.checked} />
          <TCheckBox {...props} />
        </TCheckBoxWrapper>
      );
    };
    const toggle = async (id, showed) => {
      try {
        seloading(true)
        const refresh = await checkAuth()
        if (refresh) {
          const deleteProd = await $api.get(`${BACKURL}/api/scladshops/switch/${id}`)
          setSaleReportForms(deleteProd.data)
          Notify.addNotification({
            title: "Готово!",
            message: showed ? 'Форма отчета о продажах отключена!' : 'Форма отчета о продажах включена!',
            type: "success",
            insert: "bottom",
            container: "bottom-center",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 5000,
              onScreen: true
            }
          });
        }
        seloading(false)

      } catch (e) {
        // console.log(e)
        Notify.addNotification({
          title: "Ошибка!",
          message: "Произошла непредвиденная ошибка!",
          type: "danger",
          insert: "bottom",
          container: "bottom-center",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: true
          }
        })
      }
    };
    const addProduct = () => {
      setCreateSRModal(true)
    }
    const handleDateChange = dates => {
      // console.log(dates)
      const [start, end] = dates;
      setStartDateForm(start);
      setEndDateForm(end);
    };
    const deleteIt = async (id) => {
      try {
        seloading(true)
        const refresh = await checkAuth()
        if (refresh) {
          const deleteProd = await $api.get(`${BACKURL}/api/salereports/deleteform/${id}`)
          setSaleReportForms(deleteProd.data)
          Notify.addNotification({
            title: "Готово!",
            message: "Форма отчета о продажах успешно удалена!",
            type: "success",
            insert: "bottom",
            container: "bottom-center",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 5000,
              onScreen: true
            }
          });
        }
        seloading(false)

      } catch (e) {
        seloading(false)
        Notify.addNotification({
          title: "Ошибка!",
          message: "Произошла непредвиденная ошибка!",
          type: "danger",
          insert: "bottom",
          container: "bottom-center",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: true
          }
        })
        // console.log(e)
      }
    }
    const submit2 = async (func, title, message, arg) => {
      confirmAlert({
        title: title,
        message: message,
        buttons: [
          {
            label: 'Да!',
            onClick: async () => await func(arg)
          },
          {
            label: 'Отмена!',
            //   onClick: () => alert('Click No')
          }
        ],
        closeOnEscape: true,
        closeOnClickOutside: true,
      });
    };
    const submit = async (func, id) => {
      confirmAlert({
        title: 'Удалить отчет?',
        message: 'Вы уверены, что хотите удалить форму отчета из системы?',
        buttons: [
          {
            label: 'Да!',
            onClick: async () => await func(id)
          },
          {
            label: 'Отмена!',
            //   onClick: () => alert('Click No')
          }
        ],
        closeOnEscape: true,
        closeOnClickOutside: true,
      });
    };


    const deleteSR = async (id) => {
      try {
        seloading(true)
        const refresh = await checkAuth()
        if (refresh) {
          const deleteProd = await $api.get(`${BACKURL}/api/salereports/delete/${id}`)
          setSaleReports(saleReports.filter(item => item.id != id))
          Notify.addNotification({
            title: "Готово!",
            message: "Отчет удален из системы!",
            type: "success",
            insert: "bottom",
            container: "bottom-center",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 5000,
              onScreen: true
            }
          });
        }
        seloading(false)

      } catch (e) {
        seloading(false)
        Notify.addNotification({
          title: "Ошибка!",
          message: "Произошла непредвиденная ошибка!",
          type: "danger",
          insert: "bottom",
          container: "bottom-center",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: true
          }
        })
        // console.log(e)
      }
    }
    const submitSR = async (func, id) => {
      confirmAlert({
        title: 'Удалить отчет?',
        message: 'Вы уверены, что хотите удалить отчет из системы?',
        buttons: [
          {
            label: 'Да!',
            onClick: async () => await func(id)
          },
          {
            label: 'Отмена!',
            //   onClick: () => alert('Click No')
          }
        ],
        closeOnEscape: true,
        closeOnClickOutside: true,
      });
    };
    const formatDate = (date) => {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0'); // месяцы с 0
      const year = String(d.getFullYear()).slice(-2); // последние две цифры года
      return `${day}.${month}.${year}`;
    };
    const showCounters = (id) => {
      setOrderId(id)
      setSRListModal(true)
    }
    const showSR = (id) => {
      stSrid(id)
      setSaleReportShow(true)
    }
    const showSRShort = (id) => {
      stSrid(id)
      setSaleReportShortShow(true)
    }
    const showSRbyId = (id) => {
      stSrid(id)
      setSaleReportShowById(true)
    }
    const showSRbyIdEdit = (id) => {
      stSrid(id)
      setSaleReportShowByIdEdit(true)
    }

    const editSR = (id) => {
      stSrid(id)
      setEditSaleReportForm(true)
    }


    const sorted = saleReports.sort((a, b) => a.id < b.id ? 1 : -1)

    const MakeXLSX = async () => {
      try {
        console.log(selectedShop, dateRange)
              const data = await $api.post(`${BACKURL}/api/xlsx/avansreports`, {
                selectedShop:selectedShop,
                dateRange:dateRange
              })

      } catch (e) {
        console.log(e)
      }
    }
    return (<>

      <div className={style.sclad_container}>
        <Button text='Создать отчет' width='350px' background='orange' onClick={addProduct} />


        <Accordion allowZeroExpanded style={{ width: '100%' }}>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>
                Формы Отчетов
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel style={{
              transform: "scale(0.65)",
              transformOrigin: "top left",
              width: `${100 / 0.65}%`,
              height: `${100 / 0.65}%`
            }} >
              <div style={{ height: '-webkit-fill-available' }}>
                {saleReportForms && (
                  <div className={style.table2}>
                    <table className={style.table}>
                      <thead className={style.tableth}>

                        <tr>
                          <td className={style.tabletd}>№</td>
                          <td className={style.tabletd}>Точки</td>
                          <td className={style.tabletd}>Счетчики</td>
                          <td className={style.tabletd}>on/off</td>
                          {!opendSmenas && (
                            <td className={style.tabletd}>Действия</td>
                          )}

                        </tr>
                      </thead>
                      {saleReportForms.map(prod2 => {
                        let shopss = ''
                        // console.log(prod2.shops)
                        for (let i = 0; i < prod2.shops.length; i++) {
                          const dd = shops.find(pr => pr.id == Number(prod2.shops[i]))
                          shopss = shopss + `${dd.name}, `
                        }
                        return (<tbody>

                          <tr>
                            <td className={style.tabletd}>{prod2.id}</td>
                            <td className={style.tabletd}>{shopss}</td>
                            <td className={style.tabletd}>
                              <Button text='Счетчики' background='orange' onClick={() => showCounters(prod2.id)} />

                            </td>

                            <td className={style.tabletd}>
                              <div>
                                <ToggleCheckbox checked={prod2.showed} onChange={() => toggle(prod2.id, prod2.showed)} />
                              </div>
                            </td>

                            {/* //// {!opendSmenas && ( */}


                            <td className={style.tabletd}>
                              <div className={style.cells}>

                                <div className={style.cell}>
                                  <FcEngineering
                                    onClick={() =>
                                      editSR(prod2.id)
                                    }
                                  />
                                </div>
                                <div className={style.cell}>
                                  <FcCancel
                                    onClick={() => submit(deleteIt, prod2.id)}
                                  />
                                </div>
                              </div>
                            </td>
                            {/* // )} */}


                          </tr>



                        </tbody>
                        )
                      }

                      )}
                    </table>
                  </div>


                )}
              </div>
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>
                Отчеты ежедневные
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel style={{
              transform: "scale(0.5)",
              transformOrigin: "top left",
              width: `${100 / 0.5}%`,
              height: `${100 / 0.5}%`
            }}>
              <div style={{ height: '-webkit-fill-available' }}>
                <div className={style.table2}>
                  <div style={{ width: '100%', display: "flex", margin: '10px', justifyContent: "center", alignItems: 'center' }}>
                    <Calendar style={{ width: '100%' }} onChange={async (e) => await onChangeCalendar1(e)} value={valueCalendar} />
                  </div>



              

                  <div style={{ width: '100%', display: "flex", margin: '10px', justifyContent: "center", alignItems: 'center',flexDirection:'column' }}>
    <div>
                    {dateRange[0] && dateRange[1] && (
                      <b style={{ color: 'white' }}>
                        C {dateRange[0].toLocaleDateString()} по {dateRange[1].toLocaleDateString()}
                      </b>
                    )}
                  </div>
                    <div style={{ position: 'relative' }}>
                      <Button text='Выбрать диапазон дат' width='350px' background='orange' onClick={() => setShowCalendar(!showCalendar)}

                      />

                      {showCalendar && (
                        <div style={{ position: 'fixed', zIndex: 10 }}>
                          <Calendar
                            selectRange={true}
                            onChange={handleDateChange2}
                            value={dateRange}
                          />
                        </div>
                      )}


                    </div>
                    <div>
                      {/* <label htmlFor="fruits">Выберите точку:</label> */}
                      <select id="fruits" value={selectedShop} onChange={(e) => setSelectedShop(e.target.value)}>
                        <option value={''}>Выберите точку</option>
                        <option value={JSON.stringify(shops.map(pr => pr.id))}>Отчет сразу по всем точкам</option>
                        {shops.map(shop => {
                          return <option value={JSON.stringify([shop.id])}>{shop.name}</option>
                        })}

                      </select>


                    </div>
                    <div>
                          <Button text='Выгрузить XLSX' width='250px' background='orange'
                      onClick={() => MakeXLSX()}
                    />
                    </div>
                
                  </div>
                  <div style={{ width: '100%', padding:'10px' }}>

                    {saleReports.map(prod2 => {
                      // let shopss = ''
                      // console.log(prod2.shops)
                      // for (let i = 0; i < prod2.shops.length; i++) {
                      const dd = shops.find(pr => pr.id == prod2.shop_id)
                      const smena = smenas.find(pr => pr.id == prod2.smena_id)
                      const user = admins.find(pr => pr.id == prod2.admin_id)
                      //   shopss = shopss + `${dd.name} /`
                      // const date = new formatDate(prod2.createdAt);

                      // Форматирование времени в формате HH:mm
                      // const time = ("0" + date.getUTCHours()).slice(-2) + ":" + ("0" + date.getUTCMinutes()).slice(-2);

                      // Форматирование даты в формате YYYY-MM-DD
                      const formattedDate = formatDate(prod2.createdAt)
                      return (
                        // <tbody>
                        <>
                          <div style={{ borderBottom: "2px solid white", background: prod2.confirm ? 'rgba(35, 144, 44, 1)' : 'none', width: '100%', display: "flex", textAlign: "center", flexDirection: 'row', justifyContent: "left", alignItems: 'center', color: "white" }}>
                            <div style={{ width: '10%' }}>
                              {formattedDate}</div>
                            <div style={{ width: '20%' }}>
                              <Button text='Открыть' width='50px' background='orange'
                                onClick={() => showSRbyId(prod2.id)}
                              />
                            </div>
                            <div style={{ width: '20%' }}>
                              {!prod2.confirm && prod2.type == 'NEW' && prod2.status == 'Завершен' &&
                                <Button text='Проверить/Изменить' width='100px' background='#8FC93A'
                                  onClick={() => showSRbyIdEdit(prod2.id)}
                                />
                              }
                              {prod2.confirm && prod2.type == 'NEW' && prod2.status == 'Завершен' &&
                                <Button text='Проверено' width='100px' background='#89A6FB'
                                // onClick={() => showSRbyIdEdit(prod2.id)}
                                />
                              }

                            </div>

                            <div style={{ width: '20%', fontSize: '11px' }}>
                              {dd.name}</div>
                            <div style={{ width: '20%', fontSize: '11px' }}>
                              {user.fullname.split(' ')[0]}</div>
                            <div style={{ width: '10%' }}>
                              <Button text='X' width='30px' background='#8FC93A'
                                onClick={() => submitSR(deleteSR, prod2.id)}
                              />



                            </div>
                          </div>
                        </>

                      )
                    }

                    )}
                    {/* </table> */}
                  </div>
                </div>
              </div>
            </AccordionItemPanel>

          </AccordionItem>
           <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>
                Отчеты еженедельные
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel style={{
              transform: "scale(0.5)",
              transformOrigin: "top left",
              width: `${100 / 0.5}%`,
              height: `${100 / 0.5}%`
            }}>
              <WeekReports></WeekReports>
              {/* <div style={{ height: '-webkit-fill-available' }}>
          
              </div> */}
            </AccordionItemPanel>

          </AccordionItem>

        </Accordion >



      </div >
      {editSaleReportForm && (
        <EditSaleReportForm
          id={srid}

        />

      )}
      {avansReportsFormsModal && (
        <AvansReportForm id={form_id}>

        </AvansReportForm>
      )}
      {avansReportModal && (
        <AvansReport
          // CloseSmenaReturn={CloseSmenaReturn}
          shop={shop}

          selectedReport={selectedReport}

        />

      )}      {
        saleReportShow && (
          <SaleReport
            id={srid}

          />

        )
      }
      {
        saleReportShortShow && (
          <SaleReportShort
            id={srid}

          />

        )
      }
      {
        saleReportShowById && (
          <SaleReportShowById
            id={srid}

          />

        )
      }
      {
        saleReportShowByIdEdit && (
          <SaleReportShowByIdEdit
            id={srid}

          />

        )
      }
      {
        createSRModal && (
          <CreateSRModal


          />

        )
      }
      {
        srListModal && (
          <SRListModal
            id={orderId}

          />

        )
      }


      {
        loading && (
          <Loading loading background="rgba(255, 165, 0,0.75)" loaderColor="#3498db"></Loading>
        )
      }


    </>
    )
  }


};

export default ReportsPage;
